// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutWidget012_wrapper__G4Ptu"};